import HttpService from "@/utils/httpData";
const API_CONTROLLER = 'file/';

export default {
    upload(formData) {
        let url = API_CONTROLLER + 'upload-file';
        return HttpService.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    uploadNews(formData) {
        let url = API_CONTROLLER + 'upload';
        return HttpService.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    save(data) {
        let url = 'lesson/SaveFile';
        return HttpService.post(url, data);
    },
    
    filter(params = {}) {
        let url = 'lesson/GetListFileByUserId';
        return HttpService.get(url, params).then(res => {
            return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
        })
        .catch(e => {return false})
    },

    filterDataMedias (params = {}) {
        let apiEndpoint = `library/list-document-type_searchless`;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res && res.data && !res.data.errors && res.data.data ? res.data.data : null;
                })
                .catch(e => {return false}
        );
    },
}